
<template>
  <div>
    <!-- <mheader></mheader> -->
       <div v-show="tableData.length>0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
              
        <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
                  <p class="mt-2 font">
                    <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                    <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                      库存对账   
                    </span>
                    <span class="ml-5">
                           <span>
                                    总共有
                                          <span style="color:green;font-size:20px">{{Record}}</span>
                                    条数据
                                      </span>
                                      <span>
                                         <span class="ml-3">
                                             库存合计:
                                         </span>
                                              <span class="good_font">¥{{pageTotalMoney}}</span>
                                      </span>
                                      <span>
                                         <span class="ml-3">
                                             查询总金额:
                                         </span>
                                           <span class="good_font">¥{{totalMoney}}</span>
                                      </span>
                                      <span>
                                        <span class="ml-3">
                                            查询总数量:
                                        </span>
                                         <span class="totalNum">{{totalNum}}</span>
                                      </span>
                                      <span>
                                        <span class="ml-3">
                                            查询时间:
                                        </span>
                                              <span class="good_font">{{searchForm.DateSpan}}</span>
                                                   
                                      </span>
                    </span>
                    <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                    </span>
                  </p>
                    <p class="mb-2 mt-2">
                      <span  style="font-weight:600;color:red;">库存对账(双击药品名称或者生产厂家可以快速检索！)</span>
                    </p>
                    <div class="row ml-lg-2 m-0 mb-2">
                           <div class="col-lg-7">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control " v-model="searchForm.ypmc" style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        生产厂家:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                               <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                    
                                  </div>   
                               </div>    
                                 </div>
                                   
                             </div>    
                          </div>
                       </div>
                              <div class="col-lg-2">
                                  <div class="row">
                                      <div class="col-lg-6 p-0 text-center font">
                                          选择年月:
                                      </div>
                                      <div class="col-lg-6 p-0">
                                         <div>
                                            <select name="" id="" v-model="searchForm.DateSpan" class="hei font">
                                                    <option v-for="(item,index) in listTime" :key="index">{{item.name}}</option>
                                             </select>
                                         </div> 
                                      </div>
                                  </div>  
                              </div>
                              <div class="col-lg-3">  
                                  <div class="row ml-lg-5">
                                        <button class="bg-primary button_zi hei" style="width:20%;" @click="Search()">查询</button>
                                        <button class="bg-success button_zi ml-lg-3" style="width:20%;" @click="start_print()">打印</button>
                                        <button class="bg-success button_zi ml-lg-3" @click="exportExcel()">导出查询EXCEL</button>
                                  </div>
                              </div>      
                        </div> 
              <table v-if="searchData.length>0" class="table table-striped table-hover" ref="print">
                <thead>
                    <tr>
                  <th>年月</th>
                  <th>药品名称</th>
                  <th>产地名称</th>
                  <th>规格</th>
                  <th>包装</th>
                  <th>数量</th>
            
                  <th>单位</th>
                  <th>批号</th>
                  <th>定价</th>
                  <th>有效期</th>
                  <th>进价</th>
                  <th>库存金额</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in searchData" :key="index">
                  <td>{{item.dateSpan}}</td>
                  <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
                  <td @dblclick="onInputcustomerName(index)">{{item.productFactory}}</td>
                  <td>{{item.spec}}</td>
                  <td>{{item.pack}}</td>
                  <td>{{item.storeNum}}</td>
                  <td>{{item.unit}}</td>                   
                  <td>{{item.batchNum}}</td>
                  <td>{{item.price}}</td>
                  <td>{{item.dueDate}}</td>

                  <td>{{item.purchasePrice}}</td>
                  <td>{{item.storeMoney}}</td>
                    </tr>
                </tbody>
              </table>
              <table class="table table-striped table-hover" ref="print" v-else >
                <thead>
                <tr style="white-space: nowrap;">
                  <th>年月</th>
                  <th>药品名称</th>
                  <th>产地名称</th>
                  <th>规格</th>
                  <th>包装</th>
                  <th>数量</th>
            
                  <th>单位</th>
                  <th>批号</th>
                  <th>定价</th>
                  <th>有效期</th>
                  <th>进价</th>
                  <th>库存金额</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in tableData" :key="index">
                  <td>{{item.dateSpan}}</td>
                  <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
                  <td @dblclick="onInputcustomerName(index)">{{item.productFactory}}</td>
                  <td>{{item.spec}}</td>
                  <td>{{item.pack}}</td>
                  <td>{{item.storeNum}}</td>
                  <td>{{item.unit}}</td>                   
                  <td>{{item.batchNum}}</td>
                  <td>{{item.price}}</td>
                  <td>{{item.dueDate}}</td>

                  <td>{{item.purchasePrice}}</td>
                  <td>{{item.storeMoney}}</td>
                </tr>
                </tbody>
              </table>
              <p class="text-right mr-lg-4">库存总计:
                  <span class="good_font">
                      ¥{{pageTotalMoney}}
                  </span>
              </p>
              <!-- 分页 -->
                             <div class="row m-0" v-if="searchData!==0">
                                       <nav aria-label="Page navigation" style="text-align:center;" class="mb-1">
                                          <ul class="pagination">
                                            <li class="page-item ml-5" :class="PageNo<=1?'disabled':''" @click="prePage()">
                                              <a aria-label="Previous" class="page-link">
                                                <span aria-hidden="true">&laquo;</span>
                                              </a>
                                            </li>
                                           
                                            <li :class="index==PageNo?'active':''" class="page-item" v-for="index of Pcount" :key="index"
                                                @click="curPage(index)">
                                                <a class="page-link" v-if="index<=20">{{index}}</a>
                                                <a class="page-link" v-if="index>20 && index==(Pcount-1)">...</a>
                                                <a class="page-link" v-if="index>20 && index==Pcount">{{Pcount}}</a>
                                            </li>
                                            
                                            <li class="page-item" :class="PageNo>=Pcount?'disabled':''" @click="nextPage()">
                                              <a aria-label="Next" class="page-link">
                                                <span aria-hidden="true">&raquo;</span>
                                              </a>
                                            </li>
                                          </ul>
                                    </nav>
                             </div>
                               <p class="text-center">
                                    <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                               </p>
<!--                      
                       <div class="row p-0 m-0">        
                                <p class="text-center ml-lg-5">
                                     <span>
                                              总共有
                                              <span style="color:green;font-size:20px">{{Record}}</span>
                                              条数据
                                      </span>
                                      <span>
                                              库存合计：<span class="good_font">¥{{pageTotalMoney}}</span>
                                      </span>
                                      <span>
                                              查询总金额: <span class="good_font">¥{{totalMoney}}</span>
                                      </span>
                                      <span>
                                              查询总数量: <span class="good_font">{{totalNum}}</span>
                                      </span>
                                      <span>
                                              查询时间:  <span class="good_font">{{searchForm.DateSpan}}</span>
                                                   
                                      </span>
                                </p>                                                                                                   
                       </div>     -->
             
            </div>
       </div>
    <!-- 表单内容 -->




            <div v-show="Pcount===0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
              
        <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
                       <p class="mt-2 font">
                    <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                    <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                      库存对账   
                    </span>
                    <span class="ml-5">
                           <span>
                                    总共有
                                          <span style="color:green;font-size:20px">{{Record}}</span>
                                    条数据
                                      </span>
                                      <span>
                                         <span class="ml-3">
                                             库存合计:
                                         </span>
                                              <span class="good_font">¥{{pageTotalMoney}}</span>
                                      </span>
                                      <span>
                                         <span class="ml-3">
                                             查询总金额:
                                         </span>
                                           <span class="good_font">¥{{totalMoney}}</span>
                                      </span>
                                      <span>
                                        <span class="ml-3">
                                            查询总数量:
                                        </span>
                                         <span class="totalNum">{{totalNum}}</span>
                                      </span>
                                      <span>
                                        <span class="ml-3">
                                            查询时间:
                                        </span>
                                              <span class="good_font">{{searchForm.DateSpan}}</span>
                                                   
                                      </span>
                    </span>
                    <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                    </span>
                  </p>
                    <p class="mb-2 mt-2">
                      <span  style="font-weight:600;color:red;">库存对账(双击药品名称或者生产厂家可以快速检索！)</span>
                    </p>
                    <div class="row ml-lg-2 m-0 mb-2">
                           <div class="col-lg-7">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control " v-model="searchForm.ypmc" style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        生产厂家:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                               <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                    
                                  </div>   
                               </div>    
                                 </div>
                                   
                             </div>    
                          </div>
                       </div>
                              <div class="col-lg-2">
                                  <div class="row">
                                      <div class="col-lg-6 p-0 text-center font">
                                          选择年月:
                                      </div>
                                      <div class="col-lg-6 p-0">
                                         <div>
                                            <select name="" id="" v-model="searchForm.DateSpan" class="hei font">
                                                    <option v-for="(item,index) in listTime" :key="index">{{item.name}}</option>
                                             </select>
                                         </div> 
                                      </div>
                                  </div>  
                              </div>
                              <div class="col-lg-3">  
                                  <div class="row ml-lg-5">
                                        <button class="bg-primary button_zi hei" style="width:20%;" @click="Search1()">查询</button>
                                        <button class="bg-success button_zi ml-lg-3" style="width:20%;" @click="start_print()">打印</button>
                                        <button class="bg-success button_zi ml-lg-3" @click="exportExcel()">导出查询EXCEL</button>
                                  </div>
                              </div>      
                        </div> 
                                <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">
                               <p class="text-center">
                                    <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                               </p>

             
            </div>
       </div>




         
   
            <div>
              <transition name="fade">
                <loading v-if="isLoading"></loading>
              </transition>
            </div>
    <!-- Footer -->
    <!-- <mfooter></mfooter> -->
  </div>
</template>
<script>
  // import mheader from '../components/Header.vue'
  // import mfooter from '../components/Footer.vue'
  import Loading from '../components/Loading.vue'


  export default {
    name: 'goodsCheck',
    data() {
      return {
          Height:0,
        searchForm: {
          ypmc: '',
          cdmc: '',
          ph: '',
          gg: '',
          DateSpan:''
        },//搜索内容
        listTime:[
          {name:''},
          {name:''}   
        ],
        searchData: [],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record: '',//总记录数
        Pcount: '',//总页数
        PageNo: 1, //当前页
        pageTotalMoney:'',
        totalNum:'',
        totalMoney:'',
        excelData:[]
      }
    },
    components: {
      // mheader,
      // mfooter,
      Loading,

      
    },
    computed: {
          
         
    },
   
    methods: {    
      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },  
        //计算时间方法
         getLastMonthYestdy(Month,index){

    var date = new Date();

    var daysInMonth = new Array([0],[31],[28],[31],[30],[31],[30],[31],[31],[30],[31],[30],[31]);  

    var strYear = date.getFullYear();    

    var strDay = date.getDate();    

    var strMonth = date.getMonth()+1;  

    if(strYear%4 == 0 && strYear % 100 != 0){  

       daysInMonth[2] = 29;  

    }  

    if(strMonth - Month == 0)  

    {  

       strYear -= 1;  
     
       strMonth = 12;  

    } else if(strMonth-Month==-1){
          strYear-=1;
          strMonth=11
        } 

    else  

    {  

       strMonth -= Month;  

    }  

    strDay = daysInMonth[strMonth] >= strDay ? strDay : daysInMonth[strMonth];  

    if(strMonth<10)    

    {    

       strMonth="0"+strMonth;    

    }  

    if(strDay<10)    

    {    

       strDay="0"+strDay;    

    }  
    var datastr =''+strYear+strMonth;
   this.listTime[index].name=datastr;

 },

      //导出查询
        exportExcel() {
               const that=this
                require.ensure([], async () => {
                  const { export_json_to_excel } = require('../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["年月","药品名称","产地名称","规格","包装","数量","单位","批号","定价","有效期","进价",'库存金额']; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['dateSpan','drugName', 'productFactory', 'spec','pack','storeNum','unit','batchNum','price','dueDate','purchasePrice','storeMoney']; // 上面的index、nickName、name是tableData里对象的属性key值
                     await that.getExcelData()
                      const list = that.excelData
                      // console.log(list)
                     const data = that.formatJson(filterVal, list);
                     export_json_to_excel(tHeader, data, '库存对账');//最后一个是表名字
                })
              },
              formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
              },
      //验证
          //  ypmc:function(){
          //     let reg1=/^[\u4e00-\u9fa5]{0,}$/;
          //      if(!reg1.test(this.searchForm.ypmc)){
          //            $("#ypmc").removeClass("d-none")
          //      }
          //      else{
          //           $("#ypmc").addClass("d-none")
          //      }
          // },
          // ph:function(){
          //      let reg2=/^[0-9]*$/;
          //      if(!reg2.test(this.searchForm.ph)){
          //            $("#ph").removeClass("d-none")
          //      }
          //      else{
          //           $("#ph").addClass("d-none")
          //      }
          // },
          // sccj:function(){
          //       let reg3=/^[\u4e00-\u9fa5]{0,}$/;
          //       if(!reg3.test(this.searchForm.cdmc)){
          //            $("#sccj").removeClass("d-none")
          //      }
          //      else{
          //            $("#sccj").addClass("d-none")
          //      }
          // },
         
     onInputdrugName:function(index){
          if(this.searchData.length>0){
            this.searchForm.ypmc=this.searchData[index].drugName;
          }
          else {
            this.searchForm.ypmc=this.tableData[index].drugName;
          }
      },
      onInputcustomerName:function(index){
          if(this.searchData.length>0)
          {
             this.searchForm.cdmc=this.searchData[index].productFactory
          }
          else
          {
            this.searchForm.cdmc=this.tableData[index].productFactory;
          }  
      },
      getClerkGoodsCheck: async function (PageIndex) {
        //  this.isLoading=true;
        this.PageNo = PageIndex || this.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action:'ClerkGoodsCheck',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            DateSpan:this.searchForm.DateSpan
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
          this.tableData = obj.rows
          this.Pcount = obj.pcount
          this.Record = obj.record
          this.pageTotalMoney = obj.pageTotalMoney
          this.totalMoney = obj.totalMoney
          this.totalNum = obj.totalNum
          // this.isLoading = false
         
        }
      },
      getExcelData: async function () {
           this.isLoading=true;
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkGoodsCheck',
          obj: JSON.stringify({
             PageIndex:1,
             PageSize:50000,
              DrugName: this.searchForm.ypmc.trim(),
            ProductFactory: this.searchForm.cdmc.trim(),
            BatchNum: this.searchForm.ph.trim(),
            Spec: this.searchForm.gg.trim(),
            DateSpan:this.searchForm.DateSpan
          })
        })
        //  console.log(res)
        if (res.isok) {
          const obj = res.data
          this.excelData = obj.rows
          this.isLoading=false;

        }
      },

      Search: async function (PageIndex) {
           //这里加表单验证，这块就不用我说了吧
        //假设表单验证通过，这时候就可以ajax提交表单
        const that = this
        // search 是 v-model="search" 的 search
        this.isLoading=true;
         if(!PageIndex){PageIndex=1}
          that.PageNo = PageIndex || that.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'ClerkGoodsCheck',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            DrugName: that.searchForm.ypmc.trim(),
            ProductFactory: that.searchForm.cdmc.trim(),
            BatchNum: that.searchForm.ph.trim(),
            Spec: that.searchForm.gg.trim(),
            DateSpan:that.searchForm.DateSpan
          })
        })
        // console.log(res)
        if(res.isok){
              const obj = res.data
              that.searchData = obj.rows
              that.Pcount = obj.pcount
              that.Record = obj.record
              that.pageTotalMoney = obj.pageTotalMoney
              that.totalMoney = obj.totalMoney
              that.totalNum = obj.totalNum
              that.isLoading=false;
              if(obj.pcount==0){
                    alert('没有符合条件的信息')
                     that.getClerkGoodsCheck();
              }
         
          }
         
      },
      Search1: async function (PageIndex) {
           //这里加表单验证，这块就不用我说了吧
        //假设表单验证通过，这时候就可以ajax提交表单
        const that = this
        // search 是 v-model="search" 的 search
        this.isLoading=true;
         if(!PageIndex){PageIndex=1}
          that.PageNo = PageIndex || that.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'ClerkGoodsCheck',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            DrugName: that.searchForm.ypmc.trim(),
            ProductFactory: that.searchForm.cdmc.trim(),
            BatchNum: that.searchForm.ph.trim(),
            Spec: that.searchForm.gg.trim(),
            DateSpan:that.searchForm.DateSpan
          })
        })
        // console.log(res)
        if(res.isok){
              const obj = res.data
              that.tableData = obj.rows
              that.Pcount = obj.pcount
              that.Record = obj.record
              that.pageTotalMoney = obj.pageTotalMoney
              that.totalMoney = obj.totalMoney
              that.totalNum = obj.totalNum
              that.isLoading=false;
              if(obj.pcount==0){
                    alert('没有符合条件的信息')
                     that.getClerkGoodsCheck();
              }
         
          }
         
      },
      curPage: function (index) {
         if(this.searchData.length>0){
            this.Search(index)
         }
         else{
           this.getClerkGoodsCheck(index)
         }
      },
      //上一页
      prePage: function () {
        if (this.PageNo > 1) {
          this.PageNo--;
           if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{

            this.getClerkGoodsCheck(this.PageNo);
          }
        }
      },
      //下一页
      nextPage: function () {
        if (this.PageNo < this.Pcount) {
          this.PageNo++;
          if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{

            this.getClerkGoodsCheck(this.PageNo);
          }
        }
      },
     

      // 打印
      start_print() {
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
      }

    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
    created() {
      this.getLastMonthYestdy(1,0);
      this.getLastMonthYestdy(2,1);
      this.searchForm.DateSpan=this.listTime[0].name;
      this.getClerkGoodsCheck();
      
    }
  }
</script>
<style scoped>
  .table-hover > tbody > tr:hover {
    background-color: #dee2e6 !important;
  }
  .good_font{
    color:red;
    font-weight: 500;
  }
  .hei{
    height:1.5rem;
  }
  .font{
    font-size:15px;
  }
  .font_yz{
    font-size:1px;
    color:red;
  }
  .button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .span_close:hover{
       color:#3190e8;
 }
 .totalNum{
   color:green;
   font-weight:500;
 }
</style>


// WEBPACK FOOTER //
// src/pages/GoodsCheck.vue